export enum ThemePalettes {
	OVERMAP = "overmap",
	FUTURE = "future",
	SOLAR = "solar",
	RUBY = "ruby",
	ENERGY = "energy",
	HIVE = "hive",
	TRANSFORM = "transform",
	COPPER = "copper",
	SLATE = "slate",
}
